import React from "react";
import "./ConfirmUserActionModal.css";
import { CheckIcon, TrashIcon } from "../../icons/reactIcons";

interface ConfirmUserActionModalProps {
  type: "delete" | "activate";
  userName: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ConfirmUserActionModal: React.FC<ConfirmUserActionModalProps> = ({
  type,
  userName,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const isDelete = type === "delete";
  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-content">
        <h2 className="confirm-modal-title">
          {isDelete ? "Delete User" : "Activate User"}
        </h2>
        <div className="confirm-modal-middle">
          <div className="confirm-modal-icon">
            {isDelete ? (
              <TrashIcon style={{ fontSize: "40px", color: "#000" }} />
            ) : (
              <CheckIcon style={{ fontSize: "40px", color: "#000" }} />
            )}
          </div>

          <p className="confirm-modal-text">
            Are you sure you want to {isDelete ? "delete" : "activate"}{" "}
            <strong>{userName}</strong>?<br />
            This action cannot be undone.
          </p>
        </div>

        <div className="confirm-modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className={`btn-confirm ${
              isDelete ? "btn-delete" : "btn-activate"
            }`}
            onClick={onConfirm}
            disabled={loading}
          >
            {isDelete ? "Delete" : "Activate"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmUserActionModal;
